import { render, staticRenderFns } from "./AnchorLinkedBlock.vue?vue&type=template&id=4f930b94&scoped=true&"
import script from "./AnchorLinkedBlock.vue?vue&type=script&lang=ts&"
export * from "./AnchorLinkedBlock.vue?vue&type=script&lang=ts&"
import style0 from "./AnchorLinkedBlock.vue?vue&type=style&index=0&id=4f930b94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f930b94",
  null
  
)

export default component.exports